/* :: Import Dependencies
{+} ---------------------------------- */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollMagic from 'scrollmagic';
import { Howl } from 'howler';
import './utilities/animation.gsap';
gsap.registerPlugin(ScrollTrigger);

/* :: Set Globals
{+} ---------------------------------- */
global.gsap = gsap;
global.greensock = gsap;
global.ScrollTrigger = ScrollTrigger;
global.ScrollMagic = ScrollMagic;
window.Howl = Howl;

/* :: Import Local
{+} ---------------------------------- */
import Router from './utilities/Router';
import core from './bootstrap';

/* :: Router Setup
{+} ---------------------------------- */
const routes = new Router({
    core
});

console.log(
    `%c🐠 Crafted by https://whiteboard.is`,
    'background: #121A38; color: #34DFF0; font-size: 13px; padding: 4px 8px;'
);

/* :: Load!
{+} ---------------------------------- */
function ready(callbackFunc) {
    if (document.readyState !== 'loading') {
        // Document is already ready, call the callback directly
        callbackFunc();
    } else if (document.addEventListener) {
        // All modern browsers to register DOMContentLoaded
        document.addEventListener('DOMContentLoaded', callbackFunc);
    } else {
        // Old IE browsers
        document.attachEvent('onreadystatechange', () => {
            if (document.readyState === 'complete') {
                callbackFunc();
            }
        });
    }
}

ready(routes.loadEvents());
